var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#CAC5C0",
    cx: 50,
    cy: 50.998,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.936 46.258c7.189-10.043 15.201-15.068 24.029-15.068 5.887 0 10.594 1.803 14.092 5.393 3.508 3.594 5.264 8.334 5.264 14.225 0 5.895-1.756 10.697-5.264 14.42-3.498 3.725-8.164 5.586-13.965 5.586-8.658 0-16.715-5.021-24.156-15.068-7.621 10.047-15.592 15.068-23.902 15.068-5.889 0-10.592-1.838-14.092-5.518-3.51-3.686-5.264-8.471-5.264-14.355 0-5.891 1.754-10.652 5.264-14.289 3.5-3.635 8.203-5.459 14.092-5.459 8.489-.004 16.45 5.022 23.902 15.065zm-3.764 4.812c-6.756-9.266-13.563-13.902-20.402-13.902-4.07 0-7.316 1.279-9.738 3.832-2.43 2.553-3.635 5.867-3.635 9.938 0 4.068 1.205 7.426 3.635 10.068 2.422 2.643 5.668 3.959 9.738 3.959 6.501 0 13.298-4.631 20.402-13.895zm7.4 0c7.021 9.264 13.9 13.895 20.658 13.895 3.973 0 7.164-1.273 9.543-3.832 2.379-2.553 3.574-5.867 3.574-9.938 0-4.238-1.195-7.643-3.574-10.195-2.379-2.552-5.654-3.832-9.809-3.832-4.156 0-8.057 1.475-11.691 4.418-2.252 1.818-5.148 4.98-8.701 9.484z",
    fill: "#0D0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/INFINITY.a4bfa06c0fe39866ee4850632d546763.svg";
export { ForwardRef as ReactComponent };